import React, {
    useState,
    useEffect
} from "react";
import {
    Row,
    Col,
    Modal
} from "react-bootstrap";
import { Viewer } from "@react-pdf-viewer/core";
import * as Icon from "react-bootstrap-icons";
import { FootnotesDataFormatter, FootnotesDataDeformatter } from "./FootnotesHelperFunctions";
import { FootnoteGrid } from "./FootnotesGridTable";

export const Poppy = (props) => {
    const [header, setHeader] = useState()
    const [data, setData] = useState([])
    const [footnotePages, setFootNotesPages] = useState([])
    const [pageFileLink, setPageFileLink] = useState("")
    const [activeFootnotePage, setActiveFootnotePage] = useState(3)
    const [totalActiveFootnotePages, setTotalActiveFootnotePages] = useState([])
    useEffect(() => {
        console.log("HEADER: ", props.header)
        setHeader(props.header)
    }, [props.header])

    useEffect(() => {
        setPageFileLink(props.filelink)
    }, [props.filelink])

    useEffect(() => {
        console.log("FOOTOTES DATA ORIGIAL FORMAT: ", props.data)
        if (props.data.data !== undefined) {
            // console.log("FOOTOTES DATA ORIGIAL FORMAT: ", props.data.data)
            const temp = FootnotesDataFormatter(props.data.data)
            setData(temp)
            setFootNotesPages([...props.data.pages])
        }
    }, [props.data])

    useEffect(() => {
        if (footnotePages.length !== 0) {
            console.log("FOOTNOTES PAGES: ", footnotePages)
            setTotalActiveFootnotePages([...new Set(footnotePages)])
            setActiveFootnotePage(footnotePages[0])
        }
    }, [footnotePages])

    const updateFootnote = (data) => {
        // console.log("UPDATED FOOTNOTES DATA FOR THE SECTION: ", data)
        setData(data);
        const temp = FootnotesDataDeformatter(data)
        // console.log("DEFORMATTED TABLE DATA TO MATCH THE ORIGINAL FORMAT: ", temp)
        props.updatefootnotedata(header, temp)
    }
    const SaveChanges = () => {
        // setRowData(tempRowData)
        updateFootnote(data)
    }

    const CloseChanges = () => {
        // setTempRowData(grid_props.rowData)
        props.onhide()
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // if the pressed key is Enter, do something with the value
            setActiveFootnotePage(e.target.value)
        }
    };

    const previousPage = () => {
        const activeIndex = totalActiveFootnotePages.indexOf(activeFootnotePage)
        if (activeIndex >= 1) {
            if (activeIndex <= totalActiveFootnotePages.length) {
                setActiveFootnotePage(totalActiveFootnotePages[activeIndex - 1])
            } else {
                setActiveFootnotePage(totalActiveFootnotePages[0])
            }
        }
    }

    const nextPage = () => {
        const activeIndex = totalActiveFootnotePages.indexOf(activeFootnotePage)
        if (activeIndex < totalActiveFootnotePages.length - 1) {
            if (activeIndex >= 1) {
                setActiveFootnotePage(totalActiveFootnotePages[activeIndex + 1])
            } else {
                setActiveFootnotePage(totalActiveFootnotePages[totalActiveFootnotePages.length - 1])
            }
        }
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="custom-footnote-modal-backdrop"
            backdrop="static"
            centered
            scrollable="false"
            className="footnotes-modal"
            onHide={() => {
                props.onHide()
            }
            }
        >
            <Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
            <Modal.Body className="flex-row-center-start">
                <Row className="no-gutter" style={{ height: "100%", width: "100%" }}>
                    {
                        activeFootnotePage !== undefined ?
                            <Col md={6}>
                                <div className="flex-row-center-center">
                                    <Icon.ChevronLeft className="k1-page-navigation-btns" style={{ margin: "0px 15px 0px 0px" }} onClick={() => previousPage()} />
                                    <div className="no-gutter flex-row-space-center">
                                        Page
                                        <input type="number"
                                            className="form-control move-left custom-input" placeholder={activeFootnotePage}
                                            value={totalActiveFootnotePages.indexOf(activeFootnotePage) + 1}
                                            onChange={event => setActiveFootnotePage(totalActiveFootnotePages[event.target.value])}
                                            onKeyDown={event => handleKeyDown(event)}
                                            autoComplete="new-password"
                                            style={{ width: 25, padding: "0px 5px", margin: "0px 5px", MozAppearance: "textfield" }}
                                        />
                                        of {totalActiveFootnotePages.length}
                                    </div>
                                    <Icon.ChevronRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 15px" }} onClick={() => nextPage()} />

                                </div>
                                <div
                                    className="pdf-wrapp er"
                                    style={{
                                        flex: 1,
                                        overflow: 'hidden',
                                        height: 680,
                                        width: 530
                                    }}
                                >
                                    <Viewer
                                        fileUrl={`${pageFileLink}${activeFootnotePage}`}
                                    />
                                </div>
                            </Col>
                            :
                            <></>
                    }
                    {activeFootnotePage !== undefined ?
                        <Col md={6} style={{ height: 678, overflowY: "auto" }}>
                            <div style={{ minWidth: "100%", padding: "0px 20px" }}>
                                <FootnoteGrid
                                    rowData={data}
                                    header={header}
                                    updateddata={(data) => updateFootnote(data)}
                                    rowSelection={'multiple'}
                                    rowMultiSelectWithClick={true}
                                    sortable={true}
                                    filter={true}
                                    resizable={true}
                                    onhide={() => props.onHide()}
                                    footnotepages={footnotePages}
                                    gotopage={(page) => props.setactivepage(page)}
                                />
                            </div>
                            <div className="intent-buttons" style={{ marginTop: 10 }}>
                                {/* <Button className="intent-save" onClick={() => SaveChanges()}> Update</Button> */}
                                {/* <a style={{ cursor: "pointer", color: "var(--theme1_tertiary)" }} onClick={() => goToPage(grid_props.footnotepages)}>Go to the footnotes page <Icon.BoxArrowInUpRight style={{ color: "var(theme1_primary)", fontSize: 12 }} /></a> */}
                                {/* <Button className="intent-skip" onClick={() => CloseChanges()}> Cancel </Button> */}
                            </div>
                        </Col>
                        :
                        <Col md={12}>
                            <div style={{ minWidth: "100%", padding: "0px 20px" }}>
                                <FootnoteGrid
                                    rowData={data}
                                    header={header}
                                    updateddata={(data) => updateFootnote(data)}
                                    rowSelection={'multiple'}
                                    rowMultiSelectWithClick={true}
                                    sortable={true}
                                    filter={true}
                                    resizable={true}
                                    footnotepages={footnotePages}
                                    gotopage={(page) => props.setactivepage(page)}
                                />
                            </div>
                            <div className="intent-buttons" style={{ marginTop: 10 }}>
                                {/* <Button className="intent-save" onClick={() => SaveChanges()}> Update</Button> */}
                                {/* <a style={{ cursor: "pointer", color: "var(--theme1_tertiary)" }} onClick={() => goToPage(grid_props.footnotepages)}>Go to the footnotes page <Icon.BoxArrowInUpRight style={{ color: "var(theme1_primary)", fontSize: 12 }} /></a> */}
                                {/* <Button className="intent-skip" onClick={() => CloseChanges()}> Cancel </Button> */}
                            </div>
                        </Col>
                    }

                </Row>
            </Modal.Body>
        </Modal>
    )
}

